// Compatibility issue data: destination keys remain stable; no DOM or React behavior.
import type { DataModel, ModelKey, ReportConfigurationLookupOption, ReportSubTab } from "../types";

export type ReportValidationSeverity = "error" | "warning";

export interface ReportValidationIssue {
    id: string;
    severity: ReportValidationSeverity;
    tab: ReportSubTab;
    title: string;
    message: string;
    fieldKey?: string;
    sectionId?: string;
    ruleSetId?: string;
    ruleId?: string;
}

export interface ReportValidationContext {
    dataModels: Record<ModelKey, DataModel>;
    frequencyOptions: ReportConfigurationLookupOption[];
    reportingPeriodOptions: ReportConfigurationLookupOption[];
    tripActivityOptions: ReportConfigurationLookupOption[];
}

export function setupIssue(id: string, title: string, message: string, fieldKey: string, severity: ReportValidationSeverity = "error"): ReportValidationIssue {
    return {
        id: `setup.${id}`,
        severity,
        tab: "setup",
        title,
        message,
        fieldKey,
    };
}

export function validationIssue(
    tab: ReportSubTab,
    id: string,
    title: string,
    message: string,
    fieldKey: string,
    metadata: Partial<Pick<ReportValidationIssue, "sectionId" | "ruleSetId" | "ruleId">> = {},
    severity: ReportValidationSeverity = "error",
): ReportValidationIssue {
    return {
        id: `${tab}.${id}`,
        severity,
        tab,
        title,
        message,
        fieldKey,
        ...metadata,
    };
}